<script lang="ts" setup>
const emits = defineEmits(['confirm'])
const props = defineProps({
  text: {
    default: ''
  },
  options: {
    default: {
      buttons: [],
      font: {
        className: '',
      },
    },
  }
})
const actionBtn = (action: any) => {
  if (action) action()
  emits('confirm')
}
</script>

<template>
  <div class="alert-comp">
    <div class="alert-frame">
      <div
          class="text-area"
          :class="[options?.font?.className]"
      >
        {{ $t(props.text ? props.text : '') }}
      </div>
      <div v-if="options.buttons?.length" class="btn-row">
        <div
            v-for="(button, index) in options.buttons"
            :key="index"
            class="confirm-btn"
            @click="actionBtn(button.onClick)"
            :style="{ color: button.color }"
        >
          {{ $t(button?.text ? button.text : '') }}
        </div>
      </div>
      <div v-else class="btn-row">
        <div class="confirm-btn" @click="emits('confirm')">{{ $t('common.confirm') }}</div>
      </div>
    </div>
  </div>
</template>

